import styled from 'styled-components';

export const Scroll = styled.div`
  max-height: 440px;
  overflow-y: auto;
  margin: 0 0 30px;
`;

export const Content = styled.div`
  margin: 30px 0;
  color: #fff;
  font-size: 16px;
  line-height: normal;
  width: 100%;
`;

export const Table = styled.table`
  margin: 0;
  font-size: 14px;
  th,
  td {
    padding: 0 5px 5px 0;
    text-align: center;
  }
  th {
    text-align: left;
    font-weight: normal;
    font-size: 16px;
    padding-bottom: 10px;
    vertical-align: top;
    font-weight: bold;
    text-align: center;
    &.center {
      text-align: center;
    }
  }
  button {
    margin: 0 0 0 1.6em;
    line-height: 1;
  }
  input,
  select {
    max-width: 80px;
    font-size: 15px;
    padding: 11px 10px 9px;
    border-radius: 4px;
    height: 30px;
    cursor: pointer;
  }
  select {
    padding: 3px;
    min-width: 172px;
    max-width: 172px;
  }
  input[type='checkbox'] {
    font-size: 12px;
    line-height: 1;
    width: 30px;
    height: 30px;
    cursor: pointer;
  }
  td > span {
    display: block;
    position: relative;
    /* color: #000; */
  }
  tr:last-of-type td {
    padding-bottom: 0;
  }
`;
